import React from 'react';
import { useCustomToast } from '../../contexts/CustomToastContext';
import { FailedIcon, SuccessRoundIcon } from '../../assets/svg';
import './CustomToast.scss';

export type IMessage = {
  success: boolean,
  text: string,
  show: boolean,
  showIcon?:boolean
}

const CustomToast = () => {
  const { message: { success, text, show,showIcon=true }, setMessage } = useCustomToast();
  return (
    <div className="d-flex justify-content-center align-items-center w-100 position-absolute">
      <div
        className={`toast-main-container ${!show ? 'toast' :!showIcon?'bg-white': 'toast-exit-active'} ${success && 'toast-success'}`}
        onClick={() => setMessage({
          text: '',
          success: false,
          show: false
        })}>
        <div className='d-flex align-items-center'>
          {showIcon && (success ? <SuccessRoundIcon height={40} width={40} /> : <FailedIcon color="#D10000" height={40} width={40} />)}
        </div>
        <p style={!showIcon?{background:'white',color:'black'}:{}}>
          {text}
        </p>
      </div>
    </div>
  );
}

export default CustomToast;
